<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="工厂日历"
      edit-title
      id-key="CalendarId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <template v-if="iShow('CalendarType')">
          <el-form-item label="类型" prop="CalendarType">
            <el-select v-model="data.CalendarType" @change="toggle">
              <el-option value="固定" label="固定"></el-option>
              <el-option value="灵活" label="灵活"></el-option>
              <el-option value="补班" label="补班"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="iShow('Calendar')">
          <el-form-item label="日历项目" prop="CalendarName">
            <template v-if="data.CalendarType == '固定'">
              <el-select v-model="data.CalendarName">
                <el-option value="星期一" label="星期一"></el-option>
                <el-option value="星期二" label="星期二"></el-option>
                <el-option value="星期三" label="星期三"></el-option>
                <el-option value="星期四" label="星期四"></el-option>
                <el-option value="星期五" label="星期五"></el-option>
                <el-option value="星期六" label="星期六"></el-option>
                <el-option value="星期天" label="星期天"></el-option>
              </el-select>
            </template>
            <template v-if="data.CalendarType == '灵活' || data.CalendarType == '补班'">
              <el-input v-model="data.CalendarName" placeholder="请输入名称" clearable="" />
            </template>
          </el-form-item>
        </template>
        <template v-if="data.CalendarType == '灵活' || data.CalendarType == '补班'">
          <el-form-item label="开始日期" prop="StartDate">
            <el-date-picker v-model.trim="data.StartDate" type="date" format="MM-dd" value-format="MM-dd" placeholder="选择时间" style="width: 100%"></el-date-picker>
          </el-form-item>

          <el-form-item label="结束日期" prop="EndDate">
            <el-date-picker v-model.trim="data.EndDate" type="date" format="MM-dd" value-format="MM-dd" placeholder="选择时间" style="width: 100%"></el-date-picker>
          </el-form-item>
        </template>
        <template v-if="iShow('Remarks')">
          <el-form-item label="备注" prop="Remarks">
            <el-input type="textarea" maxlength="80" :autosize="{ minRows: 2, maxRows: 5 }" v-model="data.Remarks" placeholder="请输入备注"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {
        CalendarId: 0,
        CalendarType: '固定',
        Calendar: '',
        CalendarName: '',
        StartDate: '',
        EndDate: '',
        Remarks: '',
        Sn:0
      },
      formApi: require('@/api/sy/formSetting').default,
      api: require('@/api/ba/calendar').default,

      showList: [],
      rules: {
        CalendarName: [{ required: true, message: '日历项目不能为空' }],
        StartDate: [{ required: true, message: '开始日期不能为空' }],
        EndDate: [{ required: true, message: '结束日期不能为空' }]
      }
    }
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split('/').join('') : location.hash.split('/').slice(1).join('')
      this.formApi.list({ type: modeName }).then(res => {
        this.showList = res.Data?.map(x => x.ShowField)
      })
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true
      return this.showList.indexOf(data) !== -1 ? true : false
    },

    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {},
    toggle() {
      this.data.EndDate = ''
      this.data.StartDate = ''
      this.data.CalendarName = ''
    },
    onClosed() {
      this.showList = []
    }
  }
}
</script>